module.exports = __webpack_public_path__ + "image/list_img4.jpg";